<template>
  <div class="confirm">
    <div @click="confirm" class="alert-wrapper">
      <slot></slot>
    </div>
    <div v-if="!showNative">
      <b-modal :id="id" :title="title" v-bind="modalOptions" @ok="emitOk" ok-only>
        <p class="my-4">{{ message }}</p>
        <template #modal-ok>{{ buttonOk }}</template>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    message: { type: String, required: true },
    title: { type: String, default: null },
    buttonOk: { type: String, default: 'OK' },
    modalOptions: { type: Object, default: () => ({})}
  },

  emits: ['ok'],

  setup({ message, title, buttonOk }, { emit }) {
    const showNative = window.isCordova()

    const emitOk = () => emit('ok')
    const confirm = () => {
      if (showNative) {
        navigator.notification.alert(
          message,
          () => {
            emitOk()
          },
          title,
          [ buttonOk ]
        )
      }
    }

    return {
      showNative,
      confirm,
      emitOk,
    }
  }
}
</script>

<style lang="scss">
.alert-wrapper {
  display: inline;
}
</style>
